// Comma-separated parent or exact hosts (set at build time via REACT_APP_BOOKING_DOMAINS).
// Per environment: UAT/live can differ. Matches exact hostname OR subdomain (uat.bookings… matches parent entry).
const bookingDomainEntries = (process.env.REACT_APP_BOOKING_DOMAINS || '')
    .split(',')
    .map(d => d.trim().toLowerCase())
    .filter(Boolean);

function hostnameMatchesBookingEntry(hostname, entry) {
    if (!hostname || !entry) return false;
    if (hostname === entry) return true;
    return hostname.endsWith('.' + entry);
}

export function isBookingDomain() {
    const hostname = window.location.hostname.toLowerCase();
    return bookingDomainEntries.some((entry) => hostnameMatchesBookingEntry(hostname, entry));
}

export function getAppBranding() {
    if (isBookingDomain()) {
        return {
            name: 'BookingBox',
            subtitle: 'Event Booking Portal',
            logoPath: '/booking-logo.svg'
        };
    }
    return {
        name: 'ClientBox',
        subtitle: 'Dealership Setup & Management',
        logoPath: '/logo.png'
    };
}
